module.exports = __webpack_public_path__ + "static/media/thumb_SEXP4403_1024a.47a4dbb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_SEXP4403_1024a.jpg
// module id = 151
// module chunks = 0